import { Col } from "reactstrap";
import { P } from "../../../../../../AbstractElements";
import { useState } from "react";
import ReactQuill from "react-quill-new";

const FormEditors = () => {
  const [value, setValue] = useState("Enter your messages...");
  return (
    <Col xs="12">
      <ReactQuill placeholder={value} onChange={setValue} />
      <P className="f-light detail-note">{"Improve product visibility by adding a compelling description."}</P>
    </Col>
  );
};

export default FormEditors;
